import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PackageOperationVO } from '@app/api/stock-service/model/packageOperationVO';
import { AppButtonComponent } from '@shared/components/app-button/app-button.component';
import { PackageInventoryItem } from '../../package-operation.config';
import {
  OperationPreviewItem,
  OperationWarehouseOption,
  PackageOperationForm,
  PackageOperationType,
} from '../package-operation.models';

interface SourcePackOption {
  label: string;
  value: number;
}

@Component({
  selector: 'app-package-operation-form-dialog',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    InputNumberModule,
    ReactiveFormsModule,
    SelectModule,
    TextareaModule,
    TranslateModule,
    AppButtonComponent,
  ],
  templateUrl: './package-operation-form-dialog.component.html',
  styleUrl: './package-operation-form-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageOperationFormDialogComponent {
  @Input({ required: true }) visible = false;
  @Input() operationType: PackageOperationType | null = null;
  @Input() packageSku: PackageInventoryItem | null = null;
  @Input({ required: true }) operationForm!: PackageOperationForm;
  @Input() warehouseOptions: OperationWarehouseOption[] = [];
  @Input() sourcePacks: PackageOperationVO[] = [];
  @Input() sourcePacksLoading = false;
  @Input() previewItems: OperationPreviewItem[] = [];
  @Input() stockEnough: boolean | null = null;
  @Input() validationMessage: string | null = null;
  @Input() stockChecking = false;
  @Input() submitting = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() warehouseChange = new EventEmitter<void>();
  @Output() quantityChange = new EventEmitter<void>();
  @Output() sourcePackChange = new EventEmitter<void>();
  @Output() submitOperation = new EventEmitter<void>();

  constructor(private readonly translateService: TranslateService) {}

  sourcePackOptions(): SourcePackOption[] {
    return this.sourcePacks.map((pack) => ({
      label: this.translateService.instant('package_operation.form.source_pack_option', {
        operationNo: pack.operationNo ?? '-',
        quantity: pack.remainingUnpackQty ?? 0,
      }),
      value: pack.id ?? 0,
    }));
  }

  close(): void {
    this.visibleChange.emit(false);
  }
}
